import { connect } from 'react-redux';
import AppContainer from '../../components/AppContainer';

const mapState = ({
    auth: { actions, user, menus },
    dialogs: { readingNotification },
    notifications: { allNotifications, branchNumber, lastNotificationId },
    branches: { branchString, branches },
}) => {
    return {
        authenticated: !!user.name,
        user: user,
        actions: actions,
        menus: menus,
        readingNotification: readingNotification,
        branches: branches,
        notifications: allNotifications,
        branchNumber: branchNumber,
        branchString: branchString,
        lastNotificationId: lastNotificationId,
    };
};

const mapDispatch = (dispatch) => ({
    getSettings: (payload) => dispatch.auth.getSettingsAsync(payload),
    getNotifications: () => dispatch.notifications.getNotificationsAsync(),
    setAllowanceDialog: () => dispatch.dialogs.setAllowanceDialog(),
});

export default connect(mapState, mapDispatch)(AppContainer);
